
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Spinner from '../Spinner/Spinner';
import useAuth from '../hooks/useAuth';

const AdminRoute = ({ children, ...rest }) => {
    const { user } = useAuth();
    if (!user.email) { return <Spinner /> }
    return (
        <Route
            {...rest}
            render={({ location }) =>
                user.email ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/signin",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default AdminRoute;